import { useRecoilState, useRecoilValue } from 'recoil';

import { userSettingsState, weatherForecastState } from '@store';

import { segmentEventTypes } from '../components/segment/segmentEventTypes';
import { segmentTrackEvent } from '../components/segment/SegmentTrackEvent';

const weatherMapData = {
  radar: { featureId: 'radar', segmentId: 'a' },
  futureRadar: { featureId: 'future radar', segmentId: 'b' },
  satellite: { featureId: 'satellite', segmentId: 'c' },
  temperature: { featureId: 'temperatures', segmentId: 'd' },
  feelsLike: { featureId: 'feels like', segmentId: 'e' },
  wind: { featureId: 'winds', segmentId: 'f' },
  lightning: { featureId: 'ligthing and radar', segmentId: 'g' },
  breathingIndex: { featureId: 'breathing index', segmentId: 'o' },
  alerts: { featureId: 'active alerts', segmentId: 'p' },
  severeAlerts: {
    featureId: 'severe thunderstorm watch/warning',
    segmentId: 'k',
  },
  TORNADO_WATCH_WARNING: {
    featureId: 'tornado watch/warning',
    segmentId: 'j',
  },
  FLASH_FLOOD_WATCH_WARNING: {
    featureId: 'flash flood watch/warning',
    segmentId: 'l',
  },
  EXTREME_WIND_WATCH_WARNING: {
    featureId: 'extreme wind watch/warning',
    segmentId: 'm',
  },
  AIR_QUALITY: { featureId: 'air quality', segmentId: 'n' },
};

export const useSegmentTrackWeatherMap = () => {
  const [weatherForecastCount, setWeatherForecastCount] = useRecoilState(weatherForecastState);
  const settings = useRecoilValue(userSettingsState);
  const nextWeatherCount = weatherForecastCount + 1;

  const setSegmentTrackMap = () => {
    setWeatherForecastCount(nextWeatherCount);

    segmentTrackEvent(segmentEventTypes.MAP, settings, {
      weatherMap: {
        weatherForecastCount: nextWeatherCount,
      },
    });
  };

  const setSegmentTrackMapOverlay = (type, view) => {
    setWeatherForecastCount(nextWeatherCount);

    segmentTrackEvent(segmentEventTypes.MAP_OVERLAY, settings, {
      weatherMap: {
        featureId: weatherMapData[type].featureId,
        mwSegmentId: weatherMapData[type].segmentId,
        mapView: view,
        weatherForecastCount: nextWeatherCount,
      },
    });
  };

  return {
    setSegmentTrackMapOverlay,
    setSegmentTrackMap,
  };
};
